<main
  class="position-relative box-border flex flex-col gap-6 items-start p-16 w-full bg-blue-200 bg-opacity-20 max-md:p-8 max-sm:p-4 main-container"
>
  <h1
    class="text-xl font-bold leading-10 text-blue-950 lg:text-4xl md:text-3xl sm:text-2xl leading-tight"
  >
    Find the right used spare parts
  </h1>

  <div class="flex flex-col gap-6 items-start w-full position-relative">
    <section
      class="flex gap-6 items-center p-2 w-full bg-white rounded-xl shadow-[0px_0px_12px_rgba(0,0,0,0.20)] max-sm:flex-col max-sm:gap-3 md:flex-row md:gap-3"
    >
      <!-- Registration Number Field -->
      <div
        class="flex relative flex-1 flex-col w-full max-sm:w-full px-2 py-1.5 bg-white rounded-lg input-field md:min-w-[140px]"
      >
        <label
          for="registrationNo"
          class="text-sm font-medium leading-5 text-black text-left"
        >
          Registration No
        </label>
        <input
          #registrationInput
          id="registrationNo"
          [(ngModel)]="searchData.registrationNo"
          (ngModelChange)="onRegistrationNoChange()"
          (keydown)="preventInvalidInput($event)"
          pattern="^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
          maxlength="10"
          minlength="10"
          [disabled]="
            !!searchData.brand &&
            !!searchData.registrationNo &&
              searchData.registrationNo.length < 8 &&
              isValidRegistrationNo
          "
          placeholder="E.g. MH14GH9900"
          class="text-base font-bold leading-6 w-full text-left placeholder:text-left focus:outline-none focus:ring-0 focus:border-transparent cursor-pointer"
        />
        <span
          class="absolute left-0 top-7 text-xl font-light leading-6 text-blue-500"
        ></span>
      </div>

      <!-- Divider -->
      <div
        class="w-full h-[1px] rounded-lg bg-stone-300 max-sm:w-full max-sm:h-[1px] md:w-px md:h-10 ortabbar"
      ></div>

      <!-- OR Separator -->
      <div
        class="w-[31px] h-[31px] mt-[-25px] mb-[-10px] max-sm:mt-[-25px] max-sm:mb-[-10px] md:ml-[-24px] md:mt-0 md:mb-0 text-sm font-medium leading-5 text-black bg-white border border-solid border-neutral-300 rounded-[32px] flex items-center justify-center md:w-6 md:h-6 ortab"
      >
        OR
      </div>

      <div
        class="flex relative flex-1 flex-col w-full max-sm:w-full px-2 py-1.5 bg-white rounded-lg input-field md:min-w-[120px]"
        #brandInput
      >
        <label
          for="brand"
          class="text-sm font-medium leading-5 text-black text-left"
        >
          Brand
        </label>

        <input
          id="brand"
          [(ngModel)]="searchData.brand"
          (click)="
            openDropdown(); $event.preventDefault(); $event.stopPropagation()
          "
          autocomplete="off"
          readonly
          [disabled]="!!searchData.registrationNo"
          placeholder="Select Brand"
          class="text-base font-bold leading-6 text-neutral-500 bg-transparent border-none outline-none w-full appearance-none pr-8 text-left placeholder:text-left cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis"
        />

        <!-- Keep the dropdown icon for visual consistency -->
        <svg
          class="absolute right-2 top-7"
          [class.cursor-pointer]="!searchData.registrationNo"
          [class.pointer-events-none]="!!searchData.registrationNo"
          (click)="
            openDropdown(); $event.preventDefault(); $event.stopPropagation()
          "
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.60156 9L11.8945 14.2929C12.285 14.6834 12.9181 14.6834 13.3087 14.2929L18.6016 9"
            [attr.stroke]="searchData.registrationNo ? '#E5E7EB' : 'black'"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </div>

      <div
        class="w-full h-[1px] rounded-lg bg-stone-300 max-sm:w-full max-sm:h-[1px] md:w-px md:h-10"
      ></div>

      <!-- Model Field -->
      <div
        class="flex relative flex-col w-full max-sm:w-full flex-1 px-2 py-1.5 bg-white rounded-lg input-field md:min-w-[120px]"
        #modelInput
        [class.opacity-50]="!isModelEnabled || !!searchData.registrationNo"
        [class.pointer-events-none]="
          !isModelEnabled || !!searchData.registrationNo
        "
      >
        <label
          for="model"
          class="text-sm font-medium leading-5 text-left"
          [ngClass]="{
            'text-black': isModelEnabled && !searchData.registrationNo,
            'text-neutral-400': !isModelEnabled || !!searchData.registrationNo,
          }"
          >Model</label
        >

        <input
          id="model"
          [(ngModel)]="searchData.model"
          (click)="
            openDropdownmodel();
            $event.preventDefault();
            $event.stopPropagation()
          "
          autocomplete="off"
          readonly
          placeholder="Select Model"
          [disabled]="!isModelEnabled || !!searchData.registrationNo"
          class="text-base font-bold leading-6 bg-transparent border-none outline-none w-full appearance-none pr-8 text-left placeholder:text-left cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis"
          [ngClass]="{
            'text-neutral-500 placeholder:text-neutral-500':
              isModelEnabled && !searchData.registrationNo,
            'text-neutral-400 placeholder:text-neutral-400':
              !isModelEnabled || !!searchData.registrationNo,
          }"
        />
        <svg
          class="absolute right-2 top-7"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.19922 9L11.4921 14.2929C11.8826 14.6834 12.5158 14.6834 12.9063 14.2929L18.1992 9"
            [attr.stroke]="
              isModelEnabled && !searchData.registrationNo ? 'black' : '#E5E7EB'
            "
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </div>

      <!-- Divider -->
      <div
        class="w-full h-[1px] rounded-lg bg-stone-300 max-sm:w-full max-sm:h-[1px] md:w-px md:h-10"
      ></div>
      <!-- Trigger Element -->
      <div
        class="flex relative flex-1 px-2 py-1.5 bg-white rounded-lg input-field flex-col w-full max-sm:w-full cursor-pointer md:min-w-[160px]"
        (click)="openYearDropdown(); $event.stopPropagation()"
        [class.opacity-50]="!isYearEnabled || !!searchData.registrationNo"
        [class.pointer-events-none]="
          !isYearEnabled || !!searchData.registrationNo
        "
        #dropdownYear
      >
        <label
          for="year"
          class="text-sm font-medium leading-5 text-left whitespace-nowrap overflow-hidden text-ellipsis"
          [ngClass]="{
            'text-black': isYearEnabled && !searchData.registrationNo,
            'text-neutral-400': !isYearEnabled || !!searchData.registrationNo,
          }"
        >
          Year of Manufacture
        </label>
        <div
          class="text-base leading-6 whitespace-nowrap overflow-hidden text-ellipsis"
          [ngClass]="{
            'font-bold text-neutral-800':
              !!searchData.year && isYearEnabled && !searchData.registrationNo,
            'font-bold text-neutral-700':
              !!searchData.year &&
              (!isYearEnabled || !!searchData.registrationNo),
            'font-normal text-neutral-500':
              !searchData.year && isYearEnabled && !searchData.registrationNo,
            'font-normal text-neutral-400':
              !searchData.year &&
              (!isYearEnabled || !!searchData.registrationNo),
          }"
        >
          {{ searchData.year || "Select year" }}
        </div>
        <svg
          class="absolute right-2 top-7"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.19922 9L11.4921 14.2929C11.8826 14.6834 12.5158 14.6834 12.9063 14.2929L18.1992 9"
            [attr.stroke]="
              isYearEnabled && !searchData.registrationNo ? 'black' : '#E5E7EB'
            "
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </div>

      <!-- Divider -->
      <div
        class="w-full h-[1px] rounded-lg bg-stone-300 max-sm:w-full max-sm:h-[1px] md:w-px md:h-10"
      ></div>

      <!-- Variant Field -->
      <div
        class="flex relative flex-col w-full max-sm:w-full flex-1 px-2 py-1.5 bg-white rounded-lg input-field md:min-w-[120px]"
        #variantInput
        [class.opacity-50]="!isVariantEnabled || !!searchData.registrationNo"
        [class.pointer-events-none]="
          !isVariantEnabled || !!searchData.registrationNo
        "
      >
        <label
          for="variant"
          class="text-sm font-medium leading-5 text-left"
          [ngClass]="{
            'text-black': isVariantEnabled && !searchData.registrationNo,
            'text-neutral-400':
              !isVariantEnabled || !!searchData.registrationNo,
          }"
          >Variant</label
        >
        <input
          id="variant"
          [(ngModel)]="searchData.variant"
          (click)="
            openDropdownvariant();
            $event.preventDefault();
            $event.stopPropagation()
          "
          autocomplete="off"
          readonly
          placeholder="Select Variant"
          [disabled]="!isVariantEnabled || !!searchData.registrationNo"
          class="text-base font-bold leading-6 bg-transparent border-none outline-none w-full appearance-none pr-8 text-left placeholder:text-left cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis"
          [ngClass]="{
            'text-neutral-500 placeholder:text-neutral-500':
              isVariantEnabled && !searchData.registrationNo,
            'text-neutral-400 placeholder:text-neutral-400':
              !isVariantEnabled || !!searchData.registrationNo,
          }"
        />
        <svg
          class="absolute right-2 top-7"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.19922 9L11.4921 14.2929C11.8826 14.6834 12.5158 14.6834 12.9063 14.2929L18.1992 9"
            [attr.stroke]="
              isVariantEnabled && !searchData.registrationNo
                ? 'black'
                : '#E5E7EB'
            "
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </div>

      <!-- Divider -->
      <div
        class="w-full h-[1px] rounded-lg bg-stone-300 max-sm:w-full max-sm:h-[1px] md:w-px md:h-10"
      ></div>
      <!-- Search Button -->
      <!-- Desktop & Tablet Button (Hidden on Mobile) -->
      <button
        [disabled]="!isButtonEnabled"
        (click)="getVehicle()"
        class="hidden max-sm:hidden md:flex justify-center items-center w-12 h-12 rounded-lg flex-shrink-0"
        [ngClass]="{
          'bg-[#0A0A5F]': isButtonEnabled,
          'bg-blue-950 opacity-60': !isButtonEnabled,
        }"
        aria-label="Search for spare parts"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6569 16.6569C19.781 13.5327 19.781 8.46734 16.6569 5.34315C13.5327 2.21895 8.46734 2.21895 5.34315 5.34315C2.21895 8.46734 2.21895 13.5327 5.34315 16.6569C8.46734 19.781 13.5327 19.781 16.6569 16.6569ZM16.6569 16.6569L21 21"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <!-- Mobile Button (Hidden on Desktop & Tablet) -->
      <button
        [disabled]="!isButtonEnabled"
        (click)="getVehicle()"
        class="w-full flex md:hidden max-sm:flex items-center bg-blue-950 justify-center gap-1 p-3 text-base font-bold text-center text-white whitespace-nowrap rounded-lg"
        [ngClass]="!isButtonEnabled ? 'opacity-60' : ''"
      >
        <svg
          class="w-5 h-5"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6569 16.6569C19.781 13.5327 19.781 8.46734 16.6569 5.34315C13.5327 2.21895 8.46734 2.21895 5.34315 5.34315C2.21895 8.46734 2.21895 13.5327 5.34315 16.6569C8.46734 19.781 13.5327 19.781 16.6569 16.6569ZM16.6569 16.6569L21 21"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Search</span>
      </button>
    </section>
    <div class="w-full p-5 overflow-hidden relative">
      <!-- Auto-scroll wrapper: conditionally apply animate-scroll based on user interaction -->
      <div
        class="flex gap-5 items-center w-[100%]"
        [class.animate-scroll]="!shouldPauseScroll"
      >
        <!-- First half -->
        <div class="flex gap-5 w-1/2">
          <div
            *ngFor="let brand of brands"
            class="flex justify-center items-center w-14 h-14 bg-white rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.1)] flex-shrink-0 cursor-pointer transition-all duration-300 hover:shadow-lg hover:scale-110 hover:border hover:border-blue-200"
            (mouseenter)="onBrandHover(true)"
            (mouseleave)="onBrandHover(false)"
          >
            <img
              [src]="brand.imageUrl"
              [alt]="brand.name"
              class="w-8 h-8 object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<section
  *ngIf="dropdownVisibleYear"
  #dropdownContainerYear
  class="slide-top-bottom absolute z-50 mt-[200px] left-[55%] bg-white rounded-lg border border-neutral-200 shadow-[0_8px_24px_rgba(0,0,0,0.12)] p-4 w-96 max-md:mt-[390px] max-md:-ml-[216px] max-md:mr-0 max-md:mb-0"
>
  <div
    class="grid grid-cols-3 gap-y-2 gap-x-4 pr-1 h-auto max-h-[300px] overflow-y-auto scrollbar-hide"
  >
    <div
      *ngFor="let year of years"
      (click)="selectYear(year); $event.stopPropagation()"
      class="w-24 h-8 text-center text-Text-Black text-base font-bold leading-normal cursor-pointer hover:bg-gray-100 rounded"
    >
      {{ year }}
    </div>
  </div>
</section>
<!-- Dropdown for Brands -->
<section
  *ngIf="dropdownVisible"
  #dropdownContainer
  class="slide-top-bottom absolute p-3 bg-white rounded-lg border border-neutral-200 shadow-[0_8px_24px_rgba(0,0,0,0.12)] max-w-[368px] max-md:mt-[-450px] max-md:ml-[23px] max-md:z-[10] md:absolute md:left-0 md:right-0 md:z-10 md:px-4 md:pt-4 md:max-w-none md:mt-[204px] md:mr-[309px] md:mb-0 md:ml-[350px] max-sm:mt-[230px] brand-dropdown"
>
  <section class="flex z-0 flex-col w-full text-center max-md:max-w-full">
    <h2 class="self-start text-sm font-medium leading-none text-neutral-500">
      Popular Brands
    </h2>
    <div
      class="flex overflow-x-auto gap-5 items-center mt-2 w-full text-base font-bold text-black scrollbar-hide"
    >
      <article
        *ngFor="let brand of getPopularBrands(searchData.brand)"
        class="flex gap-2.5 items-center self-stretch my-auto whitespace-nowrap"
        (click)="selectBrand(brand.name); $event.stopPropagation()"
        style="cursor: pointer"
      >
        <img
          [src]="brand.imageUrl"
          class="object-contain shrink-0 self-stretch my-auto w-8 rounded-sm aspect-square"
          alt="{{ brand.name }} logo"
        />
        <span class="self-stretch my-auto">{{ brand.name }}</span>
      </article>
    </div>
  </section>
  <section
    class="flex overflow-x-auto z-0 gap-2 items-start mt-3 w-full text-sm leading-none text-black max-md:max-w-full max-w-full scrollbar-hide"
  >
    <!-- Loading State -->
    <div
      *ngIf="isLoadingBrands"
      class="flex justify-center items-center w-full py-4"
    >
      <p class="text-gray-500">Loading brands...</p>
    </div>

    <!-- No Brands State -->
    <div
      *ngIf="
        !isLoadingBrands &&
        (!filteredBrandsList || filteredBrandsList.length === 0)
      "
      class="flex justify-center items-center w-full py-4"
    >
      <p class="text-gray-500">No brands found matching your search</p>
    </div>

    <!-- Dynamic Columns -->
    <div
      *ngFor="let column of filteredBrandsList"
      class="flex flex-col items-start w-[156px]"
    >
      <div
        *ngFor="let section of column"
        class="flex flex-col justify-center max-w-full w-[120px]"
        [class.mt-2]="section !== column[0]"
      >
        <h3 class="font-bold">{{ section.letter }}</h3>
        <div class="flex flex-col justify-center mt-1 w-full font-medium">
          <p
            *ngFor="let brand of section.brands"
            class="mt-1"
            (click)="selectBrand(brand); $event.stopPropagation()"
            style="cursor: pointer"
          >
            {{ brand }}
          </p>
        </div>
      </div>
    </div>
  </section>
</section>

<section
  *ngIf="dropdownVisiblemodel"
  #dropdownContainermodel
  class="slide-top-bottom absolute left-0 right-0 z-10 mx-auto flex flex-col overflow-hidden bg-white p-4 rounded-lg border border-neutral-200 shadow-[0_8px_24px_rgba(0,0,0,0.12)] w-[600px] max-md:p-3 max-md:w-full max-md:max-w-[991px] max-sm:p-2 max-sm:max-w-screen-sm max-sm:w-[356px] max-sm:h-auto mt-[204px] mr-[200px] mb-0 ml-[600px] max-sm:mt-[305px] md:z-[100] max-sm:mr-[0px] max-sm:mb-[0px] max-sm:ml-[22px] max-sm:overflow-x-auto max-sm:overflow-y-auto model-dropdown"
>
  <section class="flex z-0 flex-col w-full text-center max-md:max-w-full">
    <h2
      class="self-start text-sm font-medium leading-none text-neutral-500 mb-3"
    >
      Popular Models
    </h2>
    <!-- <div class="flex overflow-x-auto gap-5 items-center mt-2 w-full text-base font-bold text-black scrollbar-hide"> -->
    <!-- <article *ngFor="let brandCategory of selectedBrandmodelList" 
        class="flex gap-2.5 items-center self-stretch my-auto whitespace-nowrap">
        <span class="self-stretch my-auto">{{ brandCategory.brandCategory }}</span>
      </article> -->
    <div
      class="flex overflow-x-auto gap-5 items-center mt-2 w-full text-base font-bold text-black scrollbar-hide"
      *ngIf="modelimages && modelimages?.length > 0"
    >
      <article
        *ngFor="let model of modelimages"
        class="flex gap-2.5 items-center self-stretch my-auto whitespace-nowrap cursor-pointer"
        (click)="selectModel(model?.model); $event.stopPropagation()"
      >
        <img
          [src]="model?.image_path"
          class="object-contain shrink-0 self-stretch my-auto w-8 rounded-sm aspect-square"
          alt="{{ model?.model }} logo"
        />
        <span class="self-stretch my-auto cursor-pointer">{{
          model?.model
        }}</span>
      </article>
    </div>
    <!-- </div> -->
  </section>
  <section
    class="flex gap-6 max-md:flex-wrap max-sm:flex-col max-sm:gap-3 mt-4 max-h-[400px] max-sm:max-h-[200px] overflow-y-auto"
  >
    <!-- Loading State -->
    <div
      *ngIf="!selectedBrandmodelList || selectedBrandmodelList.length === 0"
      class="flex justify-center items-center w-full py-4"
    >
      <p class="text-gray-500">No models available for selected brand</p>
    </div>

    <!-- Brand Categories with Models -->

    <div class="grid grid-cols-3 gap-4">
      <div
        *ngFor="let group of selectedBrandmodelList"
        class="flex flex-col gap-2"
      >
        <h4 class="text-sm font-bold text-black">{{ group.letter }}</h4>
        <div class="flex flex-col gap-1 max-h-[200px] overflow-y-auto">
          <p
            *ngFor="let model of group.models"
            class="text-sm text-black cursor-pointer hover:text-blue-600 font-medium py-1 rounded hover:bg-gray-50"
            (click)="selectModel(model); $event.stopPropagation()"
          >
            {{ model }}
          </p>
        </div>
      </div>
    </div>
    <!-- <div *ngFor="let brandCategory of selectedBrandmodelList" class="flex flex-col gap-3 min-w-[350px]">
      <div class="grid grid-cols-3 gap-4">
        <div *ngFor="let group of brandCategory.models" class="flex flex-col gap-2">

          <h4 class="text-sm font-bold text-black">{{ group.letter }}</h4>
          <div class="flex flex-col gap-1 max-h-[200px] overflow-y-auto">
            <p *ngFor="let model of group.models" 
              class="text-sm text-black cursor-pointer hover:text-blue-600 font-medium py-1 rounded hover:bg-gray-50" 
              (click)="selectModel(model)">
              {{ model }}
            </p>
          </div>
        </div>
      </div>
    </div> -->
  </section>
</section>

<!-- Variant Dropdown -->
<section
  *ngIf="dropdownVisiblevariant"
  #dropdownContainervariant
  class="slide-top-bottom absolute left-120 right-[-100px] z-10 mx-auto flex flex-col overflow-hidden bg-white p-4 rounded-lg border border-neutral-200 shadow-[0_8px_24px_rgba(0,0,0,0.12)] w-[320px] max-md:p-3 max-md:w-full max-md:max-w-[320px] max-sm:p-2 max-sm:max-w-screen-sm max-sm:w-[320px] mt-[204px] mr-[200px] mb-0 ml-[600px] max-sm:mt-[475px] md:z-[100] max-sm:mr-[0px] max-sm:mb-[0px] max-sm:ml-[22px] variant-dropdown"
>
  <div
    class="w-80 p-3 bg-white rounded-lg inline-flex flex-col justify-start items-start gap-2 overflow-hidden"
  >
    <div class="self-stretch flex flex-col justify-start items-start gap-3">
      <!-- Fuel Type Section -->
      <div class="self-stretch flex flex-col justify-start items-start gap-1">
        <div
          class="self-stretch justify-start text-Text-Caption text-sm font-medium leading-tight"
        >
          Fuel Type
        </div>
        <div class="self-stretch flex flex-wrap gap-2">
          <div
            *ngFor="let fuelType of fuelTypes"
            class="px-3 py-1 bg-Neutrals-Off-White rounded-[45px] inline-flex justify-center items-center gap-1 cursor-pointer bg-gray-100 hover:bg-gray-300"
            [class.bg-blue-100]="selectedFuelType === fuelType"
          >
            <!-- (click)="selectFuelType(fuelType)" -->
            <div
              class="justify-start text-Neutrals-Black text-sm font-medium leading-tight"
            >
              {{ fuelType }}
            </div>
          </div>
        </div>
      </div>

      <!-- Variants Section -->
      <div class="w-full flex flex-col justify-start items-start gap-1">
        <div
          class="self-stretch justify-start text-Text-Caption text-sm font-medium leading-tight"
        >
          Variants
        </div>
        <div
          class="self-stretch flex flex-col justify-start items-start gap-1 max-h-[200px] overflow-y-auto"
        >
          <div
            *ngIf="variantData.variants.length === 0"
            class="text-gray-500 text-sm py-2"
          >
            No variants available for the selected model
          </div>
          <div
            *ngFor="let variant of variantData.variants"
            class="self-stretch justify-start text-black text-sm font-bold leading-tight cursor-pointer hover:text-blue-600 hover:bg-gray-50 py-1 rounded"
            (click)="
              selectVariantFromDropdown(variant); $event.stopPropagation()
            "
          >
            {{ variant }}
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<main
  *ngIf="showVehiclePopup"
  class="fixed inset-0 z-50 flex justify-center items-center bg-black/30 max-sm:justify-start max-sm:items-end max-sm:p-0"
  (click)="handleOverlayClick($event)"
>
  <article
    class="flex overflow-hidden flex-col items-center pb-6 bg-white rounded-2xl shadow-sm max-w-[644px] w-full max-sm:w-full max-sm:max-w-none max-sm:mx-0 max-sm:mb-0 max-sm:rounded-t-2xl max-sm:rounded-b-none max-sm:max-h-[90vh] max-sm:overflow-y-auto"
    (click)="$event.stopPropagation()"
  >
    @if (vehicleDetails?.Vehicle_Data?.length > 0) {
      <header
        class="flex flex-wrap gap-10 justify-between items-center self-stretch px-4 py-3 w-full text-2xl font-bold leading-none border-b border-solid border-b-[color:var(--Neutrals-Light-Grey,#C0C5C7)] text-blue-950 max-md:max-w-full max-sm:gap-4 max-sm:text-xl"
      >
        <h1 class="self-stretch my-auto max-sm:text-lg">
          Is this vehicle correct ?
        </h1>
        <button (click)="handleClose()" aria-label="Close">
          <img
            [src]="closeIconUrl"
            class="object-contain shrink-0 self-stretch my-auto w-8 aspect-square"
            alt="Close"
          />
        </button>
      </header>

      <section
        class="flex flex-col justify-center items-center p-4 ml-10 mt-2 w-full max-w-[564px] max-md:max-w-full max-sm:ml-0 max-sm:p-3 max-sm:mt-1"
      >
        <img
          [src]="
            vehicleDetails?.image_data[0]?.image_path_x
              ? vehicleDetails?.image_data[0]?.image_path_x
              : vehicleImage
          "
          class="object-contain max-w-full aspect-[1.78] w-[213px] max-sm:w-[180px]"
          [alt]="vehicleTitle"
        />
        <h2
          class="self-stretch mt-2 text-lg font-bold leading-none text-center text-blue-950 max-md:max-w-full max-sm:text-base max-sm:mt-1"
        >
          {{ vehicleDetails?.vehicle_brand || "-" }}
          {{ vehicleDetails?.vehicle_model || "-" }}
          {{ vehicleDetails?.vehicle_variant || "-" }}
        </h2>

        <div
          class="flex flex-wrap gap-2 justify-between items-center mt-2 w-full text-sm leading-none px-3 py-0 max-md:px-2 max-sm:gap-1 max-sm:px-2 max-sm:mt-1"
        >
          <section
            class="flex flex-col grow shrink justify-center self-stretch my-auto w-[125px] max-sm:mb-2 max-sm:w-[106px]"
          >
            <h3 class="font-medium text-neutral-500 text-sm leading-none">
              Brand
            </h3>
            <p class="mt-1 font-bold text-black text-sm leading-none">
              {{ vehicleDetails?.vehicle_brand || "-" }}
            </p>
          </section>
          <section
            class="flex flex-col grow shrink justify-center self-stretch my-auto w-[125px] max-sm:mb-2 max-sm:w-[106px]"
          >
            <h3 class="font-medium text-neutral-500 text-sm leading-none">
              Engine type
            </h3>
            <p class="mt-1 font-bold text-black text-sm leading-none">
              {{ vehicleDetails?.vehicle_version[0]?.engine_type || "-" }}
            </p>
          </section>
          <section
            class="flex flex-col grow shrink justify-center self-stretch my-auto w-[125px] max-sm:mb-2 max-sm:w-[106px]"
          >
            <h3 class="font-medium text-neutral-500 text-sm leading-none">
              Engine Litre
            </h3>
            <p class="mt-1 font-bold text-black text-sm leading-none">
              {{ vehicleDetails?.vehicle_version[0]?.engine_litre || "-" }}
            </p>
          </section>
          <section
            class="flex flex-col grow shrink justify-center self-stretch my-auto w-[125px] max-sm:mb-2 max-sm:w-[106px]"
          >
            <h3 class="font-medium text-neutral-500 text-sm leading-none">
              Power
            </h3>
            <p class="mt-1 font-bold text-black text-sm leading-none">
              {{ vehicleDetails?.vehicle_version[0]?.max_power_kw || "-" }}
              <span
                *ngIf="vehicleDetails?.data?.vehicle_version[0]?.max_power_kw"
                >KW</span
              >
            </p>
          </section>
          <section
            class="flex flex-col grow shrink justify-center self-stretch my-auto w-[125px] max-sm:mb-2 max-sm:w-[106px]"
          >
            <h3 class="font-medium text-neutral-500 text-sm leading-none">
              Brake Type
            </h3>
            <p class="mt-1 font-bold text-black text-sm leading-none">
              {{ vehicleDetails?.vehicle_version[0]?.brake_type || "-" }}
            </p>
          </section>
          <section
            class="flex flex-col grow shrink justify-center self-stretch my-auto w-[125px] max-sm:mb-2 max-sm:w-[106px]"
          >
            <h3 class="font-medium text-neutral-500 text-sm leading-none">
              Transmission Type
            </h3>
            <p class="mt-1 font-bold text-black text-sm leading-none">
              {{ vehicleDetails?.vehicle_version[0]?.transmission_type || "-" }}
            </p>
          </section>
        </div>
      </section>

      <footer
        class="flex flex-wrap gap-6 justify-center items-start mt-6 w-full text-base font-bold text-center max-w-[564px] max-md:max-w-full max-sm:gap-3 max-sm:mt-4 max-sm:px-3"
      >
        <button
          (click)="handleCancel()"
          class="flex gap-1 justify-center items-center p-2 rounded-lg border text-blue-950 w-[164px] max-sm:w-[140px] max-sm:text-sm"
          aria-label="No"
        >
          <span class="gap-2 self-stretch my-auto">No</span>
        </button>
        <button
          (click)="handleConfirm()"
          class="flex gap-1 justify-center items-center p-2 text-white whitespace-nowrap rounded-lg bg-blue-950 w-[164px] max-sm:w-[140px] max-sm:text-sm"
          aria-label="Yes"
        >
          <span class="gap-2 self-stretch my-auto">Yes</span>
        </button>
      </footer>
    } @else {
      <div class="rounded-2xl max-w-sm w-full p-6 text-center mx-4">
        <!-- Icon -->
        <div
          class="mx-auto mb-4 flex items-center justify-center w-14 h-14 rounded-full bg-gray-100"
        >
          <svg
            class="w-8 h-8 text-gray-500"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3m0 3h.01m-6.938 4h13.856c1.054 0 1.665-1.14 1.158-2.046L13.158 4.954a1.25 1.25 0 00-2.316 0L4.924 16.954C4.417 17.86 5.028 19 6.082 19z"
            />
          </svg>
        </div>

        <!-- Title -->
        <h2 class="text-xl font-semibold text-gray-800">No Vehicle Found</h2>

        <!-- Message -->
        <p class="text-gray-500 text-sm mt-2">
          We couldn’t find any vehicles matching your search
          {{ searchData.registrationNo }}. Try a different registration number.
        </p>

        <!-- Button -->
        <button
          (click)="handleCancel()"
          class="mt-6 w-full bg-blue-950 text-white py-2.5 rounded-xl font-medium hover:bg-blue-700 transition"
        >
          Try Again
        </button>
      </div>
    }
  </article>
</main>
